import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { AccessControl } from '@eggplant/context'
import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import { LinkToAddWebhook } from '@eggplant/routing'
import { LinkToWebhookDoc } from '../links'
import { WebhookIcon } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'

const description = `Use webhook profiles to integrate real-time notification with third-party apps such as Slack, Jira, ServiceNow, PagerDuty, and your DevOps pipeline. This is particularly useful for sending messages with your preferred apps to notify subscribers when errors occur. 

🔔 Add a new webhook profile to get started!`

const renderButton = () =>
  <AccessControl
    allowedRoles={['dai:admin']}
    isHiddenIfDenied
  >
    <LinkButton variant='primary'>
      <LinkToAddWebhook>
        <HiPlus
          aria-hidden
          size='19.2px'
        />
        New webhook profile
      </LinkToAddWebhook>
    </LinkButton>
  </AccessControl>

const WebhookIntro = () =>
  <div className='grid w-[36em]'>
    <EmptyStatesPreview
      action={renderButton()}
      description={description}
      icon={<WebhookIcon />}
      renderLink={<LinkToWebhookDoc />}
      title='Webhooks'
    />
  </div>

export default WebhookIntro
